<script setup lang="ts">
   // Explicit #imports rather than relying on auto-import: inside a brand layer these
   // two do not resolve for `nuxi typecheck` (TS2304), which the build scripts chain on.
   import { useHead, useSeoMeta } from '#imports';

   const route = useRoute();
   const path = computed(() => route.path);

   // Canonical URL + Open Graph / Twitter defaults for all public (website-layout)
   // pages. Driven by NUXT_PUBLIC_SITE_DOMAIN so it matches the sitemap and schema.
   // Per-page og:title/og:description fall back to each page's <title>/description.
   const config = useRuntimeConfig();
   const siteUrl = ((config.public.siteDomain as string) || 'https://www.ipolo.org').replace(/\/+$/, '');
   const siteName = (config.public.siteName as string) || 'International Polo';
   const canonicalUrl = computed(() => `${siteUrl}${route.path}`);

   useHead({
      link: [{ rel: 'canonical', href: canonicalUrl }],
   });

   useSeoMeta({
      ogType: 'website',
      ogSiteName: siteName,
      ogUrl: canonicalUrl,
      ogImage: `${siteUrl}/img/ipa-logo.png`,
      ogLocale: 'en_GB',
      twitterCard: 'summary_large_image',
      twitterSite: '@intlpolo',
   });

   //computed
   const layoutClasses = computed(() => {
      const baseClasses = new Set(['font-sans text-base']);
      const isLmsRoute = path.value.startsWith('/lms');

      // Offset the fixed IpaHeader. Its height is content-driven and changes at lg,
      // where the centred logo block appears above the nav: roughly 84px on mobile
      // against ~176px on desktop. A single pt-44 left ~90px of dead space on phones.
      if (!isLmsRoute) {
         baseClasses.add('pt-24 lg:pt-44');
      }

      return Array.from(baseClasses.values());
   });
</script>

<template>
   <div :class="layoutClasses">
      <WebsiteSvgSymbols />

      <DynamicHeader />

      <slot>
         <NuxtPage />
      </slot>

      <div>
         <div
            class="mx-auto mt-12 flex w-full max-w-7xl grid-cols-2 flex-col gap-9 px-5 text-gray-500 lg:grid">
            <!-- Phone number hidden per user request -->
            <!-- <div
               class="group flex flex-col items-center rounded-bl-3xl rounded-tr-3xl border-2 border-solid border-gray-500 px-3 py-4 text-lg text-gray-700 xl:flex-row">
               <div
                  class="flex w-full items-center justify-center border-b-2 border-solid border-gray-700 pb-5 pr-3 lg:w-auto xl:border-b-0 xl:border-r-2 xl:py-2">
                  <svg class="size-7">
                     <use href="#lp-icon-phone"></use>
                  </svg>
               </div>
               <div class="ml-0 mt-5 xl:ml-3 xl:mt-0">+442081640865</div>
            </div> -->

            <div
               class="group flex flex-col items-center rounded-bl-3xl rounded-tr-3xl border-2 border-solid border-gray-500 px-3 py-4 text-lg text-gray-700 xl:flex-row">
               <div
                  class="flex w-full items-center justify-center border-b-2 border-solid border-gray-700 pb-5 pr-3 lg:w-auto xl:border-b-0 xl:border-r-2 xl:py-2">
                  <svg class="size-7">
                     <use href="#lp-icon-envelope"></use>
                  </svg>
               </div>
               <div class="ml-0 mt-5 xl:ml-3 xl:mt-0">
                  info@internationalpoloacademy.com
               </div>
            </div>
         </div>
      </div>

      <WebsiteFooter />
   </div>
</template>

<style scoped></style>
